import {alias, createModelSchema, reference} from "serializr";

import {TriggerBase} from "./core/TriggerBase";
import {TriggerKind} from "./core/TriggerKind";
import {TriggerScope} from "./core/TriggerScope";
import {RedactorUtils} from "../../core/RedactorUtils";
import {Schema} from "@/common/Schema";


export class TriggerQuest extends TriggerBase {

    constructor() {
        super(TriggerKind.QUEST);
        this._questUID = null;
    }

    get questUID() {
        return this._questUID;
    }

    set questUID(value) {
        this._questUID = value;
    }

    valid() {

        if (!super.valid()) {
            return false;
        }

        if (!this.questUID || !RedactorUtils.getQuest(this.questUID)) {
            return false;
        }

        return true;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TriggerQuest());
        } else if (target instanceof TriggerQuest) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

export class TriggerQuestScope extends TriggerScope {
    static _values = [
        //new TriggerQuestScope(1, "AVAILABLE"),
        new TriggerQuestScope(2, "ACTIVE"),
        new TriggerQuestScope(3, "PASSED"),
        new TriggerQuestScope(4, "CLOSED")
    ];

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, TriggerQuestScope.getValue(id));
        });
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new TriggerQuestScope());
        } else if (target instanceof TriggerQuestScope) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(TriggerQuest, {
    _scope: alias("scope", TriggerQuestScope.schema()),
    _questUID: alias("quest_uid", Schema.primitive())
});
